<template>
  <div style="height: 100%; width: 100%">
    <div class="close-container" @click="backHome">
      <span style="margin: 0 2px">{{ $t("modalCloseText") }}</span>
      <svg
        class="icon--pressed"
        width="24px"
        height="24px"
        viewBox="0 0 24 24"
        version="1.1"
        xmlns="http://www.w3.org/2000/svg"
        xmlns:xlink="http://www.w3.org/1999/xlink"
      >
        <g
          id="Icons/close"
          stroke="none"
          stroke-width="1"
          fill="none"
          fill-rule="evenodd"
        >
          <path
            d="M11.8766417,2.00829893 C11.4329138,2.0684958 11.0909091,2.44885362 11.0909091,2.90909091 L11.089697,11.0909091 L2.90909091,11.0909091 L2.7730982,11.1018835 C2.3164165,11.1835228 2,11.558745 2,12 L2.00829893,12.1233583 C2.0684958,12.5670862 2.44885362,12.9090909 2.90909091,12.9090909 L11.089697,12.9090909 L11.0909091,21.0909091 L11.1018835,21.2269018 C11.1835228,21.6835835 11.558745,22 12,22 L12.1233583,21.9917011 C12.5670862,21.9315042 12.9090909,21.5511464 12.9090909,21.0909091 L12.9078788,12.9090909 L21.0909091,12.9090909 L21.2269018,12.8981165 C21.6835835,12.8164772 22,12.441255 22,12 L21.9917011,11.8766417 C21.9315042,11.4329138 21.5511464,11.0909091 21.0909091,11.0909091 L12.9078788,11.0909091 L12.9090909,2.90909091 L12.8981165,2.7730982 C12.8164772,2.3164165 12.441255,2 12,2 L11.8766417,2.00829893 Z"
            id="Combined-Shape"
            fill="#D83C3E"
            transform="translate(12.000000, 12.000000) rotate(-315.000000) translate(-12.000000, -12.000000) "
          ></path>
        </g>
      </svg>
    </div>
    <div v-if="isGuest">
      <!-- <email-login /> -->
      <sms-login />
    </div>
  </div>
</template>

<script>
import SmsLogin from "@/components/Login/SmsLogin";
import EmailLogin from "@/components/Login/EmailLogin";
export default {
  name: "login",
  mounted() {
    this.$store.dispatch("resetError");
  },
  computed: {
    isGuest() {
      if (this.$store.getters.isGuest) {
        return this.$store.getters.isGuest;
      } else {
        if (this.$store.getters.loginStatus === 2) {
          return true;
        } else {
          this.$router.push("/");
        }
      }
    },
    status() {
      return this.$store.getters.loginStatus;
    },
    error() {
      return this.$store.getters.loginError;
    },
    cssVariable() {
      return {
        "--color": this.$store.getters.primaryColor,
        "--color2": this.$store.getters.secondaryColor
      };
    },
    lang() {
      return this.$store.getters.lang;
    },
    logo() {
      return this.$store.getters.brandLogo;
    }
  },
  methods: {
    backHome() {
      let competetionId = localStorage.getItem("competitionId");
      if (competetionId) {
        this.$router.push({ name: "home", params: { id: competetionId } });
      } else {
        this.$router.push({ name: "competitions" });
      }
    }
  },
  components: {
    SmsLogin,
    EmailLogin
  }
};
</script>

<style scoped>
/* common css classes */
main {
  background: #fff;
  height: 100%;
  color: #101010;
  text-align: center;
  font-size: 1.5rem;
  padding-top: 35px;
  overflow-y: scroll;
  /* -webkit-overflow-scrolling: touch; */
}
.close-container {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  height: 30px;
  padding: 20px;
}
.company-logo {
  width: 50%;
  margin: 20px auto;
  margin-bottom: 30px;
}
.company-logo img {
  height: 100px;
  width: 100%;
  object-fit: contain;
}
.login-form {
  padding: 10px;
  font-size: 12px;
  text-align: start;
}
.button-submit {
  color: var(--color2);
  background-color: var(--color);
  width: 80%;
  font-weight: 700;
  margin: 0 auto;
  margin-top: 20px;
  font-size: 14px;
  padding: 10px;
}
.label {
  padding-left: 10px;
}
.custom-login-input {
  border-radius: 6px;
  background-color: #f6f6f6;
  padding: 20px 10px 10px;
  margin-bottom: 10px !important;
  margin-top: 20px !important;
}

/* code verification screen */
.verification-main {
  background: #fff;
  height: 100%;
  color: #101010;
  text-align: center;
  font-size: 1.5rem;
  overflow-y: scroll;
  /* -webkit-overflow-scrolling: touch; */
}

/* information screen */
.info-main {
  background: #fff;
  height: 100%;
  color: #101010;
  text-align: center;
  font-size: 1.5rem;
  padding-top: 35px;
  overflow-y: scroll;
  /* -webkit-overflow-scrolling: touch; */
}
</style>
